import { watch, Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'

export function useQuerySync<T>(
  sourceRef: Ref<T>,
  key: string,
  parse: (val: string | null | undefined) => T,
  stringify: (val: T) => string
) {
  const route = useRoute()
  const router = useRouter()

  const initialValue = parse(route.query[key]?.toString())
  // eslint-disable-next-line no-param-reassign
  sourceRef.value = initialValue

  watch(
    sourceRef,
    (newVal) => {
      const currentVal = parse(route.query[key]?.toString())
      if (newVal !== currentVal) {
        router.push({
          query: {
            ...route.query,
            [key]: stringify(newVal),
          },
        })
      }
    },
    { immediate: true }
  )

  watch(
    () => route.query[key],
    (newVal) => {
      const parsed = parse(newVal?.toString())
      if (sourceRef.value !== parsed) {
        // eslint-disable-next-line no-param-reassign
        sourceRef.value = parsed
      }
    },
    { immediate: true }
  )
}
